/*!
 * VERSION: 0.10.1
 * DATE: 2014-03-26
 * UPDATES AND DOCS AT: http://www.greensock.com
 *
 * Requires TweenLite and CSSPlugin version 1.11.0 or later (TweenMax contains both TweenLite and CSSPlugin). ThrowPropsPlugin is required for momentum-based continuation of movement after the mouse/touch is released (ThrowPropsPlugin is a membership benefit of Club GreenSock - http://www.greensock.com/club/).
 *
 * @license Copyright (c) 2008-2014, GreenSock. All rights reserved.
 * This work is subject to the terms at http://www.greensock.com/terms_of_use.html or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */
(window._gsQueue || (window._gsQueue = [])).push(function () {
    "use strict";
    window._gsDefine(
        "utils.Draggable",
        ["events.EventDispatcher", "TweenLite"],
        function (t, e) {
            var i,
                s,
                r,
                n,
                a,
                o = { css: {} },
                h = { css: {} },
                l = { css: {} },
                u = { css: {} },
                _ = {},
                c = document,
                p = c.documentElement || {},
                f = [],
                d = function () {
                    return !1;
                },
                m = 180 / Math.PI,
                g = 999999999999999,
                v =
                    Date.now ||
                    function () {
                        return new Date().getTime();
                    },
                y = c.all && !c.addEventListener,
                T = [],
                w = {},
                x = 0,
                b = /^(?:a|input|textarea|button|select)$/i,
                P = 0,
                S = 0,
                C = function () {
                    for (var t = T.length; --t > -1; ) T[t]();
                },
                k = function (t) {
                    T.push(t), 1 === T.length && e.ticker.addEventListener("tick", C);
                },
                R = function (t) {
                    for (var i = T.length; --i > -1; ) T[i] === t && T.splice(i, 1);
                    e.to(D, 0, { overwrite: "all", delay: 15, onComplete: D });
                },
                D = function () {
                    T.length || e.ticker.removeEventListener("tick", C);
                },
                A = function (t, e) {
                    var i;
                    for (i in e) void 0 === t[i] && (t[i] = e[i]);
                    return t;
                },
                O = function (t, e) {
                    return (t = t || window.event), (_.pageX = t.clientX + c.body.scrollLeft + p.scrollLeft), (_.pageY = t.clientY + c.body.scrollTop + p.scrollTop), e && (t.returnValue = !1), _;
                },
                M = function (t) {
                    return t ? ("string" == typeof t && (t = e.selector(t)), t.length && t !== window && t[0] && t[0].style && !t.nodeType && (t = t[0]), t === window || (t.nodeType && t.style) ? t : null) : t;
                },
                L = function (t, e) {
                    var s,
                        r,
                        n,
                        a = t.style;
                    if (void 0 === a[e]) {
                        for (n = ["O", "Moz", "ms", "Ms", "Webkit"], r = 5, s = e.charAt(0).toUpperCase() + e.substr(1); --r > -1 && void 0 === a[n[r] + s]; );
                        if (0 > r) return "";
                        (i = 3 === r ? "ms" : n[r]), (e = i + s);
                    }
                    return e;
                },
                E = function (t, e, i) {
                    var s = t.style;
                    void 0 === s[e] && (e = L(t, e)), null == i ? (s.removeProperty ? s.removeProperty(e.replace(/([A-Z])/g, "-$1").toLowerCase()) : s.removeAttribute(e)) : void 0 !== s[e] && (s[e] = i);
                },
                N = c.defaultView ? c.defaultView.getComputedStyle : d,
                I = /(?:Left|Right|Width)/i,
                X = /(?:\d|\-|\+|=|#|\.)*/g,
                F = function (t, e, i, s, r) {
                    if ("px" === s || !s) return i;
                    if ("auto" === s || !i) return 0;
                    var n,
                        a = I.test(e),
                        o = t,
                        h = j.style,
                        l = 0 > i;
                    return (
                        l && (i = -i),
                        "%" === s && -1 !== e.indexOf("border")
                            ? (n = (i / 100) * (a ? t.clientWidth : t.clientHeight))
                            : ((h.cssText = "border:0 solid red;position:" + Y(t, "position", !0) + ";line-height:0;"),
                              "%" !== s && o.appendChild ? (h[a ? "borderLeftWidth" : "borderTopWidth"] = i + s) : ((o = t.parentNode || c.body), (h[a ? "width" : "height"] = i + s)),
                              o.appendChild(j),
                              (n = parseFloat(j[a ? "offsetWidth" : "offsetHeight"])),
                              o.removeChild(j),
                              0 !== n || r || (n = F(t, e, i, s, !0))),
                        l ? -n : n
                    );
                },
                U = function (t, e) {
                    if ("absolute" !== Y(t, "position", !0)) return 0;
                    var i = "left" === e ? "Left" : "Top",
                        s = Y(t, "margin" + i, !0);
                    return t["offset" + i] - (F(t, e, parseFloat(s), s.replace(X, "")) || 0);
                },
                Y = function (t, e, i) {
                    var s,
                        r = (t._gsTransform || {})[e];
                    return r || 0 === r
                        ? r
                        : (t.style[e] ? (r = t.style[e]) : (s = N(t)) ? ((r = s.getPropertyValue(e.replace(/([A-Z])/g, "-$1").toLowerCase())), (r = r || s.length ? r : s[e])) : t.currentStyle && (r = t.currentStyle[e]),
                          "auto" !== r || ("top" !== e && "left" !== e) || (r = U(t, e)),
                          i ? r : parseFloat(r) || 0);
                },
                B = function (t, e, i) {
                    var s = t.vars,
                        r = s[i],
                        n = t._listeners[e];
                    "function" == typeof r && r.apply(s[i + "Scope"] || t, s[i + "Params"] || [t.pointerEvent]), n && t.dispatchEvent(e);
                },
                z = function (t, e) {
                    var i,
                        s,
                        r,
                        n = M(t);
                    return n
                        ? ee(n, e)
                        : void 0 !== t.left
                        ? ((r = G(e)), { left: t.left - r.x, top: t.top - r.y, width: t.width, height: t.height })
                        : ((s = t.min || t.minX || t.minRotation || 0), (i = t.min || t.minY || 0), { left: s, top: i, width: (t.max || t.maxX || t.maxRotation || 0) - s, height: (t.max || t.maxY || 0) - i });
                },
                j = c.createElement("div"),
                W = "" !== L(j, "perspective"),
                H = L(j, "transformOrigin")
                    .replace(/^ms/g, "Ms")
                    .replace(/([A-Z])/g, "-$1")
                    .toLowerCase(),
                q = L(j, "transform"),
                V = q
                    .replace(/^ms/g, "Ms")
                    .replace(/([A-Z])/g, "-$1")
                    .toLowerCase(),
                Q = {},
                $ = {},
                G = function (t, e) {
                    if (((e = e || {}), !t || t === document.body || !t.parentNode)) return { x: 0, y: 0 };
                    var i = N(t),
                        s = H && i ? i.getPropertyValue(H) : "50% 50%",
                        r = s.split(" "),
                        n = -1 !== s.indexOf("left") ? "0%" : -1 !== s.indexOf("right") ? "100%" : r[0],
                        a = -1 !== s.indexOf("top") ? "0%" : -1 !== s.indexOf("bottom") ? "100%" : r[1];
                    return (
                        ("center" === a || null == a) && (a = "50%"),
                        ("center" === n || isNaN(parseFloat(n))) && (n = "50%"),
                        (e.x = -1 !== n.indexOf("%") ? (t.offsetWidth * parseFloat(n)) / 100 : parseFloat(n)),
                        (e.y = -1 !== a.indexOf("%") ? (t.offsetHeight * parseFloat(a)) / 100 : parseFloat(a)),
                        e
                    );
                },
                Z = function (t, e, i) {
                    var s, r;
                    return t !== window && t && t.parentNode
                        ? ((s = N(t)),
                          (r = s ? s.getPropertyValue(V) : t.currentStyle ? t.currentStyle[q] : "1,0,0,1,0,0"),
                          (r = (r + "").match(/(?:\-|\b)[\d\-\.e]+\b/g) || [1, 0, 0, 1, 0, 0]),
                          r.length > 6 && (r = [r[0], r[1], r[4], r[5], r[12], r[13]]),
                          e &&
                              ((r[4] = Number(r[4]) + e.x + t.offsetLeft - i.x),
                              (r[5] = Number(r[5]) + e.y + t.offsetTop - i.y),
                              void 0 === n &&
                                  c.body &&
                                  q &&
                                  (n = (function () {
                                      var t,
                                          e,
                                          i = c.createElement("div"),
                                          s = c.createElement("div");
                                      return (s.style.position = "absolute"), c.body.appendChild(i), i.appendChild(s), (t = s.offsetParent), (i.style[q] = "rotate(1deg)"), (e = s.offsetParent === t), c.body.removeChild(i), e;
                                  })()),
                              !t.parentNode || t.parentNode.offsetParent !== t.offsetParent || (n && "100100" !== Z(t.parentNode).join("")) || ((r[4] -= t.parentNode.offsetLeft), (r[5] -= t.parentNode.offsetTop))),
                          r)
                        : [1, 0, 0, 1, 0, 0];
                },
                K = function (t, e) {
                    for (var i, s, r, n, a, o, h, l, u = G(t, Q), _ = G(t.parentNode, $), c = Z(t, u, _); (t = t.parentNode) && t.parentNode && t !== document.body; )
                        (u = _),
                            (_ = G(t.parentNode, u === Q ? $ : Q)),
                            (h = Z(t, u, _)),
                            (i = c[0]),
                            (s = c[1]),
                            (r = c[2]),
                            (n = c[3]),
                            (a = c[4]),
                            (o = c[5]),
                            (c[0] = i * h[0] + s * h[2]),
                            (c[1] = i * h[1] + s * h[3]),
                            (c[2] = r * h[0] + n * h[2]),
                            (c[3] = r * h[1] + n * h[3]),
                            (c[4] = a * h[0] + o * h[2] + h[4]),
                            (c[5] = a * h[1] + o * h[3] + h[5]);
                    return (
                        e &&
                            ((i = c[0]),
                            (s = c[1]),
                            (r = c[2]),
                            (n = c[3]),
                            (a = c[4]),
                            (o = c[5]),
                            (l = i * n - s * r),
                            (c[0] = n / l),
                            (c[1] = -s / l),
                            (c[2] = -r / l),
                            (c[3] = i / l),
                            (c[4] = (r * o - n * a) / l),
                            (c[5] = -(i * o - s * a) / l)),
                        c
                    );
                },
                J = function (t, e, i) {
                    var s = K(t),
                        r = e.x,
                        n = e.y;
                    return (i = i === !0 ? e : i || {}), (i.x = r * s[0] + n * s[2] + s[4]), (i.y = r * s[1] + n * s[3] + s[5]), i;
                },
                te = function (t, e, i) {
                    var s = t.x * e[0] + t.y * e[2] + e[4],
                        r = t.x * e[1] + t.y * e[3] + e[5];
                    return (t.x = s * i[0] + r * i[2] + i[4]), (t.y = s * i[1] + r * i[3] + i[5]), t;
                },
                ee = function (t, e) {
                    var i, s, r, n, a, o, h, l, u, _, f;
                    return (
                        t === window
                            ? ((n = null != t.pageYOffset ? t.pageYOffset : null != c.scrollTop ? c.scrollTop : p.scrollTop || c.body.scrollTop || 0),
                              (s = null != t.pageXOffset ? t.pageXOffset : null != c.scrollLeft ? c.scrollLeft : p.scrollLeft || c.body.scrollLeft || 0),
                              (r = s + (p.clientWidth || t.innerWidth || c.body.clientWidth || 0)),
                              (a = n + (t.innerHeight - 20 < p.clientHeight ? p.clientHeight : t.innerHeight || c.body.clientHeight || 0)))
                            : ((i = G(t)), (s = -i.x), (r = s + t.offsetWidth), (n = -i.y), (a = n + t.offsetHeight)),
                        t === e
                            ? { left: s, top: n, width: r - s, height: a - n }
                            : ((o = K(t)),
                              (h = K(e, !0)),
                              (l = te({ x: s, y: n }, o, h)),
                              (u = te({ x: r, y: n }, o, h)),
                              (_ = te({ x: r, y: a }, o, h)),
                              (f = te({ x: s, y: a }, o, h)),
                              (s = Math.min(l.x, u.x, _.x, f.x)),
                              (n = Math.min(l.y, u.y, _.y, f.y)),
                              { left: s, top: n, width: Math.max(l.x, u.x, _.x, f.x) - s, height: Math.max(l.y, u.y, _.y, f.y) - n })
                    );
                },
                ie = function (t) {
                    return t.length && t[0] && ((t[0].nodeType && t[0].style && !t.nodeType) || (t[0].length && t[0][0])) ? !0 : !1;
                },
                se = function (t) {
                    var e,
                        i,
                        s,
                        r = [],
                        n = t.length;
                    for (e = 0; n > e; e++)
                        if (((i = t[e]), ie(i))) for (s = i.length, s = 0; i.length > s; s++) r.push(i[s]);
                        else r.push(i);
                    return r;
                },
                re = "ontouchstart" in p && "orientation" in window,
                ne = (function (t) {
                    for (
                        var e = t.split(","),
                            i = (void 0 !== j.onpointerdown ? "pointerdown,pointermove,pointerup,pointercancel" : void 0 !== j.onmspointerdown ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : t).split(","),
                            s = {},
                            r = 7;
                        --r > -1;

                    )
                        (s[e[r]] = i[r]), (s[i[r]] = e[r]);
                    return s;
                })("touchstart,touchmove,touchend,touchcancel"),
                ae = function (t, e, i) {
                    t.addEventListener ? t.addEventListener(ne[e] || e, i, !1) : t.attachEvent && t.attachEvent("on" + e, i);
                },
                oe = function (t, e, i) {
                    t.removeEventListener ? t.removeEventListener(ne[e] || e, i) : t.detachEvent && t.detachEvent("on" + e, i);
                },
                he = function (t) {
                    (s = t.touches && t.touches.length > P), oe(t.target, "touchend", he);
                },
                le = function (t) {
                    (s = t.touches && t.touches.length > P), ae(t.target, "touchend", he);
                },
                ue = function (t, e, i, s, r, n) {
                    var a,
                        o,
                        h,
                        l = {};
                    if (e)
                        if (1 !== r && e instanceof Array) for (l.end = a = [], h = e.length, o = 0; h > o; o++) a[o] = e[o] * r;
                        else
                            l.end =
                                "function" == typeof e
                                    ? function (i) {
                                          return e.call(t, i) * r;
                                      }
                                    : e;
                    return (i || 0 === i) && (l.max = i), (s || 0 === s) && (l.min = s), n && (l.velocity = 0), l;
                },
                _e = function (t) {
                    var e;
                    return t && t.getAttribute && "BODY" !== t.nodeName ? ("true" === (e = t.getAttribute("data-clickable")) || ("false" !== e && (t.onclick || b.test(t.nodeName + ""))) ? !0 : _e(t.parentNode)) : !1;
                },
                ce = (function () {
                    var t,
                        e = c.createElement("div"),
                        i = c.createElement("div"),
                        s = i.style,
                        r = c.body || j;
                    return (
                        (s.display = "inline-block"),
                        (s.position = "relative"),
                        (e.style.cssText = i.innerHTML = "width:90px; height:40px; padding:10px; overflow:auto; visibility: hidden"),
                        e.appendChild(i),
                        r.appendChild(e),
                        (a = i.offsetHeight + 18 > e.scrollHeight),
                        (s.width = "100%"),
                        q || ((s.paddingRight = "500px"), (t = e.scrollLeft = e.scrollWidth - e.clientWidth), (s.left = "-90px"), (t = t !== e.scrollLeft)),
                        r.removeChild(e),
                        t
                    );
                })(),
                pe = function (t, i) {
                    (t = M(t)), (i = i || {});
                    var s,
                        r,
                        n,
                        o,
                        h,
                        l,
                        u = c.createElement("div"),
                        _ = u.style,
                        p = t.firstChild,
                        f = 0,
                        d = 0,
                        m = t.scrollTop,
                        g = t.scrollLeft,
                        v = t.scrollWidth,
                        T = t.scrollHeight,
                        w = 0,
                        x = 0,
                        b = 0;
                    W && i.force3D !== !1 ? ((h = "translate3d("), (l = "px,0px)")) : q && ((h = "translate("), (l = "px)")),
                        (this.scrollTop = function (t, e) {
                            return arguments.length ? (this.top(-t, e), void 0) : -this.top();
                        }),
                        (this.scrollLeft = function (t, e) {
                            return arguments.length ? (this.left(-t, e), void 0) : -this.left();
                        }),
                        (this.left = function (s, r) {
                            if (!arguments.length) return -(t.scrollLeft + d);
                            var n = t.scrollLeft - g,
                                a = d;
                            return (n > 2 || -2 > n) && !r
                                ? ((g = t.scrollLeft), e.killTweensOf(this, !0, { left: 1, scrollLeft: 1 }), this.left(-g), i.onKill && i.onKill(), void 0)
                                : ((s = -s),
                                  0 > s ? ((d = 0 | (s - 0.5)), (s = 0)) : s > x ? ((d = 0 | (s - x)), (s = x)) : (d = 0),
                                  (d || a) && (h ? this._suspendTransforms || (_[q] = h + -d + "px," + -f + l) : (_.left = -d + "px"), ce && d + w >= 0 && (_.paddingRight = d + w + "px")),
                                  (t.scrollLeft = 0 | s),
                                  (g = t.scrollLeft),
                                  void 0);
                        }),
                        (this.top = function (s, r) {
                            if (!arguments.length) return -(t.scrollTop + f);
                            var n = t.scrollTop - m,
                                a = f;
                            return (n > 2 || -2 > n) && !r
                                ? ((m = t.scrollTop), e.killTweensOf(this, !0, { top: 1, scrollTop: 1 }), this.top(-m), i.onKill && i.onKill(), void 0)
                                : ((s = -s),
                                  0 > s ? ((f = 0 | (s - 0.5)), (s = 0)) : s > b ? ((f = 0 | (s - b)), (s = b)) : (f = 0),
                                  (f || a) && (h ? this._suspendTransforms || (_[q] = h + -d + "px," + -f + l) : (_.top = -f + "px")),
                                  (t.scrollTop = 0 | s),
                                  (m = t.scrollTop),
                                  void 0);
                        }),
                        (this.maxScrollTop = function () {
                            return b;
                        }),
                        (this.maxScrollLeft = function () {
                            return x;
                        }),
                        (this.disable = function () {
                            for (p = u.firstChild; p; ) (o = p.nextSibling), t.appendChild(p), (p = o);
                            t === u.parentNode && t.removeChild(u);
                        }),
                        (this.enable = function () {
                            if (((p = t.firstChild), p !== u)) {
                                for (; p; ) (o = p.nextSibling), u.appendChild(p), (p = o);
                                t.appendChild(u), this.calibrate();
                            }
                        }),
                        (this.calibrate = function (e) {
                            var i,
                                o,
                                h = t.clientWidth === s;
                            (m = t.scrollTop),
                                (g = t.scrollLeft),
                                (!h || t.clientHeight !== r || u.offsetHeight !== n || v !== t.scrollWidth || T !== t.scrollHeight || e) &&
                                    ((f || d) && ((i = this.left()), (o = this.top()), this.left(-t.scrollLeft), this.top(-t.scrollTop)),
                                    (!h || e) && ((_.display = "block"), (_.width = "auto"), (_.paddingRight = "0px"), (w = Math.max(0, t.scrollWidth - t.clientWidth)), w && (w += Y(t, "paddingLeft") + (a ? Y(t, "paddingRight") : 0))),
                                    (_.display = "inline-block"),
                                    (_.position = "relative"),
                                    (_.overflow = "visible"),
                                    (_.width = "100%"),
                                    (_.paddingRight = w + "px"),
                                    a && (_.paddingBottom = Y(t, "paddingBottom", !0)),
                                    y && (_.zoom = "1"),
                                    (s = t.clientWidth),
                                    (r = t.clientHeight),
                                    (v = t.scrollWidth),
                                    (T = t.scrollHeight),
                                    (x = t.scrollWidth - s),
                                    (b = t.scrollHeight - r),
                                    (n = u.offsetHeight),
                                    (i || o) && (this.left(i), this.top(o)));
                        }),
                        (this.content = u),
                        (this.element = t),
                        (this._suspendTransforms = !1),
                        this.enable();
                },
                fe = function (i, n) {
                    t.call(this, i),
                        (i = M(i)),
                        r || (r = (window.GreenSockGlobals || window).com.greensock.plugins.ThrowPropsPlugin),
                        (this.vars = n = n || {}),
                        (this.target = i),
                        (this.x = this.y = this.rotation = 0),
                        (this.dragResistance = parseFloat(n.dragResistance) || 0),
                        (this.edgeResistance = isNaN(n.edgeResistance) ? 1 : parseFloat(n.edgeResistance) || 0),
                        (this.lockAxis = n.lockAxis);
                    var a,
                        _,
                        p,
                        T,
                        b,
                        C,
                        D,
                        L,
                        N,
                        I,
                        X,
                        F,
                        U,
                        j,
                        W,
                        H,
                        q,
                        V,
                        Q,
                        $,
                        G,
                        Z,
                        te,
                        ee,
                        ie,
                        se = (n.type || (y ? "top,left" : "x,y")).toLowerCase(),
                        he = -1 !== se.indexOf("x") || -1 !== se.indexOf("y"),
                        ce = -1 !== se.indexOf("rotation"),
                        de = he ? "x" : "left",
                        me = he ? "y" : "top",
                        ge = -1 !== se.indexOf("x") || -1 !== se.indexOf("left") || "scroll" === se,
                        ve = -1 !== se.indexOf("y") || -1 !== se.indexOf("top") || "scroll" === se,
                        ye = this,
                        Te = M(n.trigger || n.handle || i),
                        we = {},
                        xe = 0,
                        be = function (t) {
                            if (q) {
                                var s = ye.x,
                                    r = ye.y,
                                    n = 1e-6;
                                n > s && s > -n && (s = 0),
                                    n > r && r > -n && (r = 0),
                                    ce
                                        ? ((U.rotation = ye.rotation = ye.x), e.set(i, F))
                                        : a
                                        ? (ve && a.top(r), ge && a.left(s))
                                        : he
                                        ? (ve && (U.y = r), ge && (U.x = s), e.set(i, F))
                                        : (ve && (i.style.top = r + "px"), ge && (i.style.left = s + "px")),
                                    D && !t && B(ye, "drag", "onDrag");
                            }
                            q = !1;
                        },
                        Pe = function (t, s) {
                            var r;
                            he
                                ? (i._gsTransform || e.set(i, { x: "+=0" }), (ye.y = i._gsTransform.y), (ye.x = i._gsTransform.x))
                                : ce
                                ? (i._gsTransform || e.set(i, { x: "+=0" }), (ye.x = ye.rotation = i._gsTransform.rotation))
                                : a
                                ? ((ye.y = a.top()), (ye.x = a.left()))
                                : ((ye.y = parseInt(i.style.top, 10) || 0), (ye.x = parseInt(i.style.left, 10) || 0)),
                                (!Q && !$) || s || (Q && ((r = Q(ye.x)), r !== ye.x && ((ye.x = r), ce && (ye.rotation = r), (q = !0))), $ && ((r = $(ye.y)), r !== ye.y && ((ye.y = r), (q = !0))), q && be(!0)),
                                n.onThrowUpdate && !t && n.onThrowUpdate.apply(n.onThrowUpdateScope || ye, n.onThrowUpdateParams || f);
                        },
                        Se = function () {
                            var t, e, s, r;
                            (C = !1),
                                a
                                    ? (a.calibrate(), (ye.minX = N = -a.maxScrollLeft()), (ye.minY = X = -a.maxScrollTop()), (ye.maxX = L = ye.maxY = I = 0), (C = !0))
                                    : n.bounds &&
                                      ((t = z(n.bounds, i.parentNode)),
                                      ce
                                          ? ((ye.minX = N = t.left), (ye.maxX = L = t.left + t.width), (ye.minY = X = ye.maxY = I = 0))
                                          : void 0 !== n.bounds.maxX || void 0 !== n.bounds.maxY
                                          ? ((t = n.bounds), (ye.minX = N = t.minX), (ye.minY = X = t.minY), (ye.maxX = L = t.maxX), (ye.maxY = I = t.maxY))
                                          : ((e = z(i, i.parentNode)),
                                            (ye.minX = N = Y(i, de) + t.left - e.left),
                                            (ye.minY = X = Y(i, me) + t.top - e.top),
                                            (ye.maxX = L = N + (t.width - e.width)),
                                            (ye.maxY = I = X + (t.height - e.height))),
                                      N > L && ((ye.minX = L), (ye.maxX = L = N), (N = ye.minX)),
                                      X > I && ((ye.minY = I), (ye.maxY = I = X), (X = ye.minY)),
                                      ce && ((ye.minRotation = N), (ye.maxRotation = L)),
                                      (C = !0)),
                                n.liveSnap &&
                                    ((s = n.liveSnap === !0 ? n.snap || {} : n.liveSnap),
                                    (r = s instanceof Array || "function" == typeof s),
                                    ce ? ((Q = De(r ? s : s.rotation, N, L, 1)), ($ = null)) : ((Q = De(r ? s : s.x || s.left || s.scrollLeft, N, L, a ? -1 : 1)), ($ = De(r ? s : s.y || s.top || s.scrollTop, X, I, a ? -1 : 1))));
                        },
                        Ce = function (t, e) {
                            var s, o, h;
                            t && r
                                ? (t === !0 &&
                                      ((s = n.snap || {}),
                                      (o = s instanceof Array || "function" == typeof s),
                                      (t = { resistance: (n.throwResistance || n.resistance || 1e3) / (ce ? 10 : 1) }),
                                      ce
                                          ? (t.rotation = ue(ye, o ? s : s.rotation, L, N, 1, e))
                                          : (ge && (t[de] = ue(ye, o ? s : s.x || s.left || s.scrollLeft, L, N, a ? -1 : 1, e || (ye.lockAxis && "x" === te))),
                                            ve && (t[me] = ue(ye, o ? s : s.y || s.top || s.scrollTop, I, X, a ? -1 : 1, e || (ye.lockAxis && "y" === te))))),
                                  (ye.tween = h = r.to(
                                      a || i,
                                      {
                                          throwProps: t,
                                          ease: n.ease || Power3.easeOut,
                                          onComplete: n.onThrowComplete,
                                          onCompleteParams: n.onThrowCompleteParams,
                                          onCompleteScope: n.onThrowCompleteScope || ye,
                                          onUpdate: n.fastMode ? n.onThrowUpdate : Pe,
                                          onUpdateParams: n.onThrowUpdateParams,
                                          onUpdateScope: n.onThrowUpdateScope || ye,
                                      },
                                      isNaN(n.maxDuration) ? 2 : n.maxDuration,
                                      isNaN(n.minDuration) ? 0.5 : n.minDuration,
                                      isNaN(n.overshootTolerance) ? 1 - ye.edgeResistance + 0.2 : n.overshootTolerance
                                  )),
                                  n.fastMode ||
                                      (a && (a._suspendTransforms = !0), h.seek(h.duration()), Pe(!0, !0), (ye.endX = ye.x), (ye.endY = ye.y), ce && (ye.endRotation = ye.x), h.play(0), Pe(!0, !0), a && (a._suspendTransforms = !1)))
                                : C && ye.applyBounds();
                        },
                        ke = function () {
                            var t = 1 - ye.edgeResistance;
                            (ee = K(i.parentNode, !0)),
                                ee[1] || ee[2] || 1 != ee[0] || 1 != ee[3] || (ee = null),
                                a
                                    ? (Se(), (b = a.top()), (T = a.left()))
                                    : (Re() ? (Pe(!0, !0), Se()) : ye.applyBounds(), ce ? ((H = J(i, { x: 0, y: 0 })), Pe(!0, !0), (T = ye.x), (b = ye.y = Math.atan2(H.y - p, _ - H.x) * m)) : ((b = Y(i, me)), (T = Y(i, de)))),
                                C && t && (T > L ? (T = L + (T - L) / t) : N > T && (T = N - (N - T) / t), ce || (b > I ? (b = I + (b - I) / t) : X > b && (b = X - (X - b) / t)));
                        },
                        Re = function () {
                            return ye.tween && ye.tween.isActive();
                        },
                        De = function (t, e, i, s) {
                            return "function" == typeof t
                                ? function (r) {
                                      var n = ye.isPressed ? 1 - ye.edgeResistance : 1;
                                      return t.call(ye, r > i ? i + (r - i) * n : e > r ? e + (r - e) * n : r) * s;
                                  }
                                : t instanceof Array
                                ? function (s) {
                                      for (var r, n, a = t.length, o = 0, h = g; --a > -1; ) (r = t[a]), (n = r - s), 0 > n && (n = -n), h > n && r >= e && i >= r && ((o = a), (h = n));
                                      return t[o];
                                  }
                                : isNaN(t)
                                ? function (t) {
                                      return t;
                                  }
                                : function () {
                                      return t * s;
                                  };
                        },
                        Ae = function (t) {
                            var s;
                            if (!ye.isPressed && t) {
                                if (
                                    ((ie = Re()),
                                    (ye.pointerEvent = t),
                                    ne[t.type]
                                        ? ((Z = -1 !== t.type.indexOf("touch") ? Te : c), ae(Z, "touchend", Me), ae(Z, "touchmove", Oe), ae(Z, "touchcancel", Me), ae(c, "touchstart", le))
                                        : ((Z = null), ae(c, "mousemove", Oe), ae(c, "mouseup", Me)),
                                    (G = _e(t.target) && !n.dragClickables))
                                )
                                    return ae(t.target, "change", Me), void 0;
                                y ? (t = O(t, !0)) : (t.touches && t.touches.length > P + 1) || (t.preventDefault(), t.preventManipulation && t.preventManipulation()),
                                    t.changedTouches ? ((t = j = t.changedTouches[0]), (W = t.identifier)) : t.pointerId ? (W = t.pointerId) : (j = null),
                                    P++,
                                    k(be),
                                    ye.tween && ye.tween.kill(),
                                    e.killTweensOf(a || i, !0, we),
                                    (p = ye.pointerY = t.pageY),
                                    (_ = ye.pointerX = t.pageX),
                                    ke(),
                                    ee && ((s = _ * ee[0] + p * ee[2] + ee[4]), (p = _ * ee[1] + p * ee[3] + ee[5]), (_ = s)),
                                    (ye.tween = te = null),
                                    ce || a || n.zIndexBoost === !1 || (i.style.zIndex = fe.zIndex++),
                                    (ye.isPressed = !0),
                                    (D = !(!n.onDrag && !ye._listeners.drag)),
                                    ce || E(Te, "cursor", n.cursor || "move"),
                                    B(ye, "press", "onPress");
                            }
                        },
                        Oe = function (t) {
                            if (!s && ye.isPressed) {
                                y ? (t = O(t, !0)) : (t.preventDefault(), t.preventManipulation && t.preventManipulation()), (ye.pointerEvent = t);
                                var e,
                                    i,
                                    r,
                                    n,
                                    a,
                                    o,
                                    h,
                                    l,
                                    u,
                                    c = t.changedTouches,
                                    f = 1 - ye.dragResistance,
                                    d = 1 - ye.edgeResistance;
                                if (c) {
                                    if (((t = c[0]), t !== j && t.identifier !== W)) {
                                        for (a = c.length; --a > -1 && (t = c[a]).identifier !== W; );
                                        if (0 > a) return;
                                    }
                                } else if (t.pointerId && W && t.pointerId !== W) return;
                                (h = ye.pointerX = t.pageX),
                                    (l = ye.pointerY = t.pageY),
                                    ce
                                        ? ((n = Math.atan2(H.y - t.pageY, t.pageX - H.x) * m), (o = ye.y - n), (ye.y = n), o > 180 ? (b -= 360) : -180 > o && (b += 360), (r = T + (b - n) * f))
                                        : (ee && ((u = h * ee[0] + l * ee[2] + ee[4]), (l = h * ee[1] + l * ee[3] + ee[5]), (h = u)),
                                          (i = l - p),
                                          (e = h - _),
                                          2 > i && i > -2 && (i = 0),
                                          2 > e && e > -2 && (e = 0),
                                          ye.lockAxis && (e || i) && ("y" === te || (!te && Math.abs(e) > Math.abs(i) && ge) ? ((i = 0), (te = "y")) : ve && ((e = 0), (te = "x"))),
                                          (r = T + e * f),
                                          (n = b + i * f)),
                                    Q || $ ? (Q && (r = Q(r)), $ && (n = $(n))) : C && (r > L ? (r = L + (r - L) * d) : N > r && (r = N + (r - N) * d), ce || (n > I ? (n = I + (n - I) * d) : X > n && (n = X + (n - X) * d))),
                                    (ye.x !== r || (ye.y !== n && !ce)) && ((ye.x = ye.endX = r), ce ? (ye.endRotation = r) : (ye.y = ye.endY = n), (q = !0), ye.isDragging || ((ye.isDragging = !0), B(ye, "dragstart", "onDragStart")));
                            }
                        },
                        Me = function (t, e) {
                            if (!t || !W || e || !t.pointerId || t.pointerId === W) {
                                ye.isPressed = !1;
                                var i,
                                    s,
                                    r = t,
                                    a = ye.isDragging;
                                if ((Z ? (oe(Z, "touchend", Me), oe(Z, "touchmove", Oe), oe(Z, "touchcancel", Me), oe(c, "touchstart", le)) : (oe(c, "mouseup", Me), oe(c, "mousemove", Oe)), (q = !1), G))
                                    return t && oe(t.target, "change", Me), B(ye, "release", "onRelease"), B(ye, "click", "onClick"), (G = !1), void 0;
                                if ((R(be), ce || E(Te, "cursor", n.cursor || "move"), a && ((xe = S = v()), (ye.isDragging = !1)), P--, t)) {
                                    if ((y && (t = O(t, !1)), (i = t.changedTouches), i && ((t = i[0]), t !== j && t.identifier !== W))) {
                                        for (s = i.length; --s > -1 && (t = i[s]).identifier !== W; );
                                        if (0 > s) return;
                                    }
                                    (ye.pointerEvent = r), (ye.pointerX = t.pageX), (ye.pointerY = t.pageY);
                                }
                                return (
                                    r && !a
                                        ? (ie && n.snap && Ce(n.throwProps), B(ye, "release", "onRelease"), B(ye, "click", "onClick"))
                                        : (Ce(n.throwProps), y || !r || (!n.dragClickables && _e(r.target)) || (r.preventDefault(), r.preventManipulation && r.preventManipulation()), B(ye, "release", "onRelease")),
                                    a && B(ye, "dragend", "onDragEnd"),
                                    !0
                                );
                            }
                        },
                        Le = function (t) {
                            (ye.isPressed || 20 > v() - xe) && (t.preventDefault ? t.preventDefault() : (t.returnValue = !1), t.preventManipulation && t.preventManipulation());
                        };
                    (V = fe.get(this.target)),
                        V && V.kill(),
                        (this.startDrag = function (t) {
                            Ae(t), ye.isDragging || ((ye.isDragging = !0), B(ye, "dragstart", "onDragStart"));
                        }),
                        (this.endDrag = function (t) {
                            Me(t, !0);
                        }),
                        (this.timeSinceDrag = function () {
                            return ye.isDragging ? 0 : (v() - xe) / 1e3;
                        }),
                        (this.hitTest = function (t, e) {
                            return fe.hitTest(ye.target, t, e);
                        }),
                        (this.applyBounds = function (t) {
                            var e, i;
                            return t && n.bounds !== t
                                ? ((n.bounds = t), ye.update(!0))
                                : (Pe(!0),
                                  Se(),
                                  C &&
                                      ((e = ye.x),
                                      (i = ye.y),
                                      C && (e > L ? (e = L) : N > e && (e = N), i > I ? (i = I) : X > i && (i = X)),
                                      (ye.x !== e || ye.y !== i) && ((ye.x = ye.endX = e), ce ? (ye.endRotation = e) : (ye.y = ye.endY = i), (q = !0), be())),
                                  ye);
                        }),
                        (this.update = function (t) {
                            var e = ye.x,
                                i = ye.y;
                            return t ? ye.applyBounds() : Pe(!0), ye.isPressed && (e !== ye.x || (i !== ye.y && !ce)) && ke(), ye;
                        }),
                        (this.enable = function () {
                            var t;
                            return (
                                ae(Te, "mousedown", Ae),
                                ae(Te, "touchstart", Ae),
                                ae(Te, "click", Le),
                                ce || E(Te, "cursor", n.cursor || "move"),
                                (Te.ondragstart = Te.onselectstart = d),
                                E(Te, "userSelect", "none"),
                                E(Te, "touchCallout", "none"),
                                E(Te, "touchAction", "none"),
                                r && r.track(a || i, he ? "x,y" : ce ? "rotation" : "top,left"),
                                a && a.enable(),
                                (i._gsDragID = t = "d" + x++),
                                (w[t] = this),
                                a && (a.element._gsDragID = t),
                                e.set(i, { x: "+=0" }),
                                this.update(),
                                ye
                            );
                        }),
                        (this.disable = function () {
                            var t = this.isDragging;
                            return (
                                ce || E(Te, "cursor", null),
                                e.killTweensOf(a || i, !0, we),
                                (Te.ondragstart = Te.onselectstart = null),
                                E(Te, "userSelect", "text"),
                                E(Te, "touchCallout", "default"),
                                E(Te, "MSTouchAction", "auto"),
                                oe(Te, "mousedown", Ae),
                                oe(Te, "touchstart", Ae),
                                oe(Te, "click", Le),
                                Z && (oe(Z, "touchcancel", Me), oe(Z, "touchend", Me), oe(Z, "touchmove", Oe)),
                                oe(c, "mouseup", Me),
                                oe(c, "mousemove", Oe),
                                r && r.untrack(a || i, he ? "x,y" : ce ? "rotation" : "top,left"),
                                a && a.disable(),
                                R(be),
                                (this.isDragging = this.isPressed = G = !1),
                                t && B(this, "dragend", "onDragEnd"),
                                ye
                            );
                        }),
                        (this.kill = function () {
                            return ye.disable(), delete w[i._gsDragID], ye;
                        }),
                        -1 !== se.indexOf("scroll") &&
                            ((a = this.scrollProxy = new pe(
                                i,
                                A(
                                    {
                                        onKill: function () {
                                            ye.isPressed && Me(null);
                                        },
                                    },
                                    n
                                )
                            )),
                            (i.style.overflowY = ve && !re ? "auto" : "hidden"),
                            (i.style.overflowX = ge && !re ? "auto" : "hidden"),
                            (i = a.content)),
                        n.force3D !== !1 && e.set(i, { force3D: !0 }),
                        ce ? (we.rotation = 1) : (ge && (we[de] = 1), ve && (we[me] = 1)),
                        ce ? ((F = u), (U = F.css), (F.overwrite = !1)) : he && ((F = ge && ve ? o : ge ? h : l), (U = F.css), (F.overwrite = !1)),
                        this.enable();
                },
                de = (fe.prototype = new t());
            (de.constructor = fe),
                (de.pointerX = de.pointerY = 0),
                (de.isDragging = de.isPressed = !1),
                (fe.version = "0.10.1"),
                (fe.zIndex = 1e3),
                ae(c, "touchcancel", function () {}),
                ae(c, "contextmenu", function () {
                    var t;
                    for (t in w) w[t].isPressed && w[t].endDrag();
                }),
                (fe.create = function (t, i) {
                    "string" == typeof t && (t = e.selector(t));
                    for (var s = ie(t) ? se(t) : [t], r = s.length; --r > -1; ) s[r] = new fe(s[r], i);
                    return s;
                }),
                (fe.get = function (t) {
                    return w[(M(t) || {})._gsDragID];
                }),
                (fe.timeSinceDrag = function () {
                    return (v() - S) / 1e3;
                });
            var me = function (t, e) {
                var i = t.pageX !== e ? { left: t.pageX, top: t.pageY, right: t.pageX + 1, bottom: t.pageY + 1 } : t.nodeType || t.left === e || t.top === e ? M(t).getBoundingClientRect() : t;
                return i.right === e && i.width !== e ? ((i.right = i.left + i.width), (i.bottom = i.top + i.height)) : i.width || ((i.width = i.right - i.left), (i.height = i.bottom - i.top)), i;
            };
            return (
                (fe.hitTest = function (t, e, i) {
                    if (t === e) return !1;
                    var s,
                        r,
                        n,
                        a = me(t),
                        o = me(e),
                        h = o.left > a.right || o.right < a.left || o.top > a.bottom || o.bottom < a.top;
                    return h || !i
                        ? !h
                        : ((n = -1 !== (i + "").indexOf("%")),
                          (i = parseFloat(i) || 0),
                          (s = { left: Math.max(a.left, o.left), top: Math.max(a.top, o.top) }),
                          (s.width = Math.min(a.right, o.right) - s.left),
                          (s.height = Math.min(a.bottom, o.bottom) - s.top),
                          0 > s.width || 0 > s.height ? !1 : n ? ((i *= 0.01), (r = s.width * s.height), r >= a.width * a.height * i || r >= o.width * o.height * i) : s.width > i && s.height > i);
                }),
                fe
            );
        },
        !0
    );
}),
    window._gsDefine && window._gsQueue.pop()();
